import React from 'react';
import PropTypes from 'prop-types';


const ProductNameAttr = function ProductNameAttrComponent({ value }) {
  return (
    <span className="product-table__product-name">
      { !value.url && 'This item: '}
      <a className="product-table__product-name-link" href={value.url || ''}>{value.text}</a>
    </span>
  );
};

ProductNameAttr.propTypes = {
  value: PropTypes.shape({
    url: PropTypes.string,
    text: PropTypes.string,
  }).isRequired,
};

export default ProductNameAttr;
